import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { siteInfo, categories } from '@/mocks/resources';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className={`font-heading text-xl md:text-2xl font-bold transition-colors duration-300 ${
              scrolled ? 'text-foreground-950' : 'text-white'
            }`}>
              <strong>{siteInfo.name}</strong>
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                location.pathname === '/'
                  ? scrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? scrolled
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-white/20 text-white'
                    : scrolled
                      ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer ${
                location.pathname === '/about'
                  ? scrolled
                    ? 'bg-primary-100 text-primary-700'
                    : 'bg-white/20 text-white'
                  : scrolled
                    ? 'text-foreground-600 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-lg transition-colors cursor-pointer ${
              scrolled ? 'text-foreground-800' : 'text-white'
            }`}
            aria-label="菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 shadow-lg">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer">首页</Link>
            {categories.slice(0, 4).map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer">{cat.name}</Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-primary-50 hover:text-primary-600 transition-colors cursor-pointer">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}